/**
 * Getter for auth
 */
export const getters = {
  userInfo(state) {
    return state;
  },
  getMessage(state) {
    return state.message;
  },
  getBottomMessage(state) {
    return state.bottomMessage;
  },
  checkSession(state) {
    return state.userId !== 0 && state.token !== "";
  },
  getLoadingAuth(state) {
    return state.loadingAuth;
  },
  getRouteAnimating(state) {
    return state.routeAnimating;
  },
  getUserRole(state) {
    return state.userRole;
  },
  getUserType(state) {
    return state.userType;
  },
  getNextRoute(state) {
    return state.nextRoute;
  },
  getUserDetails(state) {
    return {
      id: state.userId,
      firstName: state.firstName,
      lastName: state.lastName,
      middleName: state.middleName,
      namePrefix: state.namePrefix,
      nameSuffix: state.nameSuffix,
      credentials: state.credentials
    };
  },
  getPermittedUser(state) {
    return state.permittedUserList;
  },
  getSelectedProviderID(state) {
    return state.selectedProviderId;
  },
  getAddionalPermissionToAddEditAndDelete(state) {
    return state.addionalPermissionToAddEditAndDelete;
  },
  getAddVideoAppointmentPermission(state) {
    return state.add_video_appointment_permission;
  },
  getDeleteVideoAppointmentPermissionRefused(state) {
    return state.delete_video_appointment_permission_refused;
  },
  getSocketAuthorized(state) {
    return state.socketAuthorized;
  },
  getLoggedInTimezone(state) {
    return state.loggedInTimezone;
  },
  getShowAddToHomePopup(state) {
    return state.showAddToHomePopup;
  },
  getAddToHomeEvent(state) {
    return state.addToHomeEvent;
  },
  getShowNotificationPopup(state) {
    return state.showNotificationPopup;
  },
  getEmailTabPermission(state) {
    return state.emailTabPermission;
  },
  getUserSubscription(state) {
    return state.userSubscription;
  },
  getVideoUserId(state) {
    return state.videoUserId;
  },
  getConnectUserId(state) {
    return state.connectUserId;
  }
};
